if (!customElements.get('contact-form')) {
  class ContactForm extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-contact-form-submit]');

      this.inputs = [
        this.querySelector('#contact-form__email'),
        this.querySelector('#contact-form__body'),
      ];

      this.inputs.forEach((input) => {
        input?.addEventListener('input', () => {
          let values = [];
          this.inputs.forEach((i) => {
            values.push(i.value);
            this.button.disabled = values.includes('');
          });
        });
      });
    }
  }

  window.ContactForm = ContactForm;

  customElements.define('contact-form', ContactForm);
}
